import { logUserDataResponseError } from './processResponse';
import { UserDataStoreItem } from '../data/schema/UserDataStoreSchema';
import { makeGetRequest } from 'owa-ows-gateway';

const GET_USER_DATA_COLLECTION_NAME = 'GetUserDataCollection';
const USER_DATA_STORE_GET_COLLECTION_URL: string = 'ows/v1.0/UserDataStore/items';

/**
 * Retrieve the UserData collection for the current user, it should contains all
 * the stored info for the user.
 */
export default async function getUserDataCollectionService(): Promise<UserDataStoreItem[]> {
    try {
        const response = await makeGetRequest(USER_DATA_STORE_GET_COLLECTION_URL);
        return Promise.resolve(response as UserDataStoreItem[]);
    } catch (error) {
        logUserDataResponseError(GET_USER_DATA_COLLECTION_NAME, error?.message);
        return Promise.resolve(null);
    }
}
